export default __webpack_public_path__ + "static/portfolio-16-a3230ec05e1acfcfbfd40b07b364317d.jpg";